import { Component } from "@angular/core";
import { ViewController } from "ionic-angular";

/**
 * Generated class for the BenefitsPopoverComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: "benefits-popover",
  templateUrl: "benefits-popover.html",
})
export class BenefitsPopoverComponent {
  text: string;

  constructor(public viewCtrl: ViewController) {
    console.log("Hello BenefitsPopoverComponent Component");
    this.text = "Hello World";
  }

  addBenefit() {
    this.viewCtrl.dismiss({ add: true });
  }

  editBenefit() {
    this.viewCtrl.dismiss({ edit: true });
  }
}



// WEBPACK FOOTER //
// ./src/components/benefits-popover/benefits-popover.ts